import {
  SECRET_SANTA_FOR_CLASSROOM_PATH,
  SECRET_SANTA_FOR_COWORKERS_PATH,
  SECRET_SANTA_FOR_FAMILY_PATH,
  SECRET_SANTA_FOR_FRIENDS_PATH,
  WHITE_ELEPHANT_PATH,
  normalizePath,
} from '@src/routing/routes';
import type { LandingPageConfig } from '../types';

export const LANDING_CONFIGS: LandingPageConfig[] = [
  {
    path: SECRET_SANTA_FOR_FRIENDS_PATH,
    slug: 'friends',
    decoratedSteps: { 1: 3, 4: 8 },
    namePreset: 'friends',
    cardArt: 'friends',
  },
  {
    path: SECRET_SANTA_FOR_COWORKERS_PATH,
    slug: 'coworkers',
    decoratedSteps: { 2: 5, 3: 9, 6: 2 },
    namePreset: 'office',
    cardArt: 'coworkers',
  },
  {
    path: SECRET_SANTA_FOR_FAMILY_PATH,
    slug: 'family',
    decoratedSteps: { 1: 9, 4: 5, 6: 3 },
    namePreset: 'family',
    cardArt: 'family',
  },
  {
    path: SECRET_SANTA_FOR_CLASSROOM_PATH,
    slug: 'classroom',
    decoratedSteps: { 1: 3, 4: 8, 5: 10 },
    buttonLink: '/randomizer',
    cardArt: 'classroom',
  },
  {
    path: WHITE_ELEPHANT_PATH,
    slug: 'whiteElephant',
    decoratedSteps: { 2: 10, 3: 3, 5: 5 },
    cardArt: 'white-elephant',
  },
];

export function landingConfigFor(pathname: string): LandingPageConfig | undefined {
  const path = normalizePath(pathname);
  return LANDING_CONFIGS.find((config) => config.path === path);
}
